export default __webpack_public_path__ + "51ae3ea2465c1dd0fbf8ade5aefb75b5.png";